import { FieldsStep } from '../steps/FieldsStep';
import { CopyFromWorkspace } from './CopyFromWorkspace';

/** Step 2, Company voice and identity: Copy from another workspace, then Core values, Mission and Vision. */
export function CompanyStep({ tenantId, disabled = false }: { tenantId: string; disabled?: boolean }) {
  return (
    <>
      <CopyFromWorkspace tenantId={tenantId} disabled={disabled} />
      <FieldsStep step={2} disabled={disabled} />
    </>
  );
}
